import { Select, Space, Tag, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSiteIndex } from './useSiteIndex'

interface SiteSelectProps {
  /** antd `Form.Item` o'zi uzatadi — qo'lda berilmaydi */
  value?: string | null
  onChange?: (value: string | null) => void
  disabled?: boolean
}

/**
 * Joylashuv tanlash — shakllarda ishlatiladi (NAS, jihoz).
 *
 * ⚠️ YOPIQ RO'YXAT (`AutoComplete` emas): joylashuv id bo'yicha bog'lanadi,
 * ya'ni qo'lda yozilgan matn hech qanday yozuvga tegishli bo'lmasdi.
 * Viloyat maydonidagi holat bilan chalkashtirmang — u yerda erkin kiritish
 * MUMKIN (yangi viloyat qo'shish kerak bo'ladi), bu yerda esa yo'q.
 *
 * ⚠️ YOPILGAN joylashuv ro'yxatda QOLADI, lekin belgilangan holda: yozuv
 * o'chirilmagani uchun unga bog'langan qurilmalar bor va tahrirlashda ularning
 * joylashuvi jimgina yo'qolmasligi kerak. Yangi biriktirish uchun esa u
 * ko'rinib turgan tanlov — operator ataylab tanlaydi.
 */
export function SiteSelect({ value, onChange, disabled }: SiteSelectProps) {
  const { t } = useTranslation()
  const { sites, loading, reliable } = useSiteIndex()

  const options = sites.map((site) => ({
    value: site.id,
    label: (
      <Space size={4}>
        <span>{site.name}</span>
        <Typography.Text type="secondary">{site.region}</Typography.Text>
        {site.state === 'CLOSED' ? <Tag color="default">{t('siteState.CLOSED')}</Tag> : null}
      </Space>
    ),
    // Qidiruv NOM va VILOYAT bo'yicha: bir viloyatda o'nlab nuqta bo'lganda
    // faqat nom bo'yicha izlash yetmaydi
    title: `${site.name} ${site.region}`,
  }))

  // Tanlangan qiymat ro'yxatda yo'q (huquq yo'q yoki yozuv topilmadi) —
  // uni JIMGINA tashlab yuborish mumkin emas, aks holda formani saqlash
  // joylashuvni o'chirib yuborardi
  const missing = value && !sites.some((site) => site.id === value)

  return (
    <>
      <Select<string | null>
        allowClear
        showSearch
        value={value ?? null}
        onChange={(next) => onChange?.(next ?? null)}
        disabled={disabled}
        loading={loading}
        placeholder={t('sites.selectPlaceholder')}
        options={options}
        optionFilterProp="title"
        style={{ width: '100%' }}
        notFoundContent={reliable ? t('sites.empty') : t('sites.indexUnavailable')}
      />
      {missing ? (
        <Typography.Text type="warning" style={{ fontSize: 12 }}>
          {t('sites.selectMissing')}
        </Typography.Text>
      ) : null}
    </>
  )
}
